module.exports = __webpack_public_path__ + "img/shop_environ_1.27100814.jpg";